module.exports = __webpack_public_path__ + "static/markp-21f36494e89d4545bb6bc9f85b0c8f84.jpg";